module.exports = __webpack_public_path__ + "img/order_x.28ce9494.png";